import React from "react";
import { Link } from "react-router-dom";
import firebaseEvent from "./firebaseEvent";
import { setSelectType } from "../utils/storage";

/**
 * 문자열에서 hashtag와 나머지 문자열을 html을 포함한 문자열로 변환
 * @param str 문자열
 * @returns string
 */
export const convertStringToHashTagHtml = (str: string, args?: any) => {
  // eslint-disable-next-line
  const RegExHashTag = /(#[^\s\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]+|[^\s\{\}\[\]\/?.,;:|\)*~`!^\-+<>@\#$%&\\\=\(\'\"]+#)/gm;
  const convert = str.replace(RegExHashTag, (tag) => `[T]${tag}[T]`);
  const arr = convert.split(`[T]`);

  const firebaseHashTagEvent = (tag: string) => {
    setSelectType("hashtag");
    const replaceTag = tag.replace("#", "");
    const jsonParams = {
      P1: args.project_id,
      P2: replaceTag,
    };
    firebaseEvent("detail_hashtag", jsonParams);
  };
  return (
    <React.Fragment>
      {arr.map((item, index) => {
        if (!item || item === " ") return null;
        if (item.match(RegExHashTag)) {
          const isFirstSharp = item.indexOf("#") === 0;
          const to = `/search/${
            isFirstSharp ? encodeURIComponent(`#${item.substr(1)}`) : item
          }`;
          const label = isFirstSharp
            ? item
            : `#${item.substr(0, item.length - 1)}`;
          return (
            <Link
              key={index}
              dir={"auto"}
              to={to}
              onClick={() => firebaseHashTagEvent(label)}
            >
              {label}
            </Link>
          );
        }
        return <span key={index} dangerouslySetInnerHTML={{ __html: item }} />;
      })}
    </React.Fragment>
  );
};

/**
 * Json 문자열을 object로 변환하여 반환
 * @param str 문자열
 * @returns object
 */
export const convertStringToObject = (str: string) => {
  const decodedData = decodeURIComponent(atob(str));
  return JSON.parse(decodedData);
};

/**
 * 쿼리스트링으로 받은 language code를 loco 구조에 맞춰서 파싱
 * @param code
 */
export const convertLanguageCode = (code?: string): string => {
  const defaultCode = "en";

  if (!code) return defaultCode;

  let languageCode: RegExpMatchArray | string | null = code.match(
    // eslint-disable-next-line
    /^[a-zA-Z]{2}/
  );
  let countryCode: RegExpMatchArray | string | null = code.match(
    // eslint-disable-next-line
    /\-[a-zA-Z]{2}$/
  );

  if (languageCode === null) return defaultCode;

  languageCode = languageCode[0].toLowerCase();

  if (countryCode !== null) {
    // eslint-disable-next-line
    countryCode = countryCode[0].replace(/\-/, "").toLowerCase();
  }

  if (languageCode === "zh") {
    if (countryCode === null || countryCode === "cn") return "zh-Hans";
    return "zh-Hant";
  }

  return languageCode;
};

/**
 * like, download count 표시
 * @param count
 */
export const convertCount = (value: number) => {
  if (value > 999 && value < 1000000) {
    return (value / 1000).toFixed(1) + "K"; // convert to K for number from > 1000 < 1 million
  }
  if (value > 1000000) {
    return (value / 1000000).toFixed(1) + "M"; // convert to M for number from > 1 million
  }
  return String(value); // if value < 1000, nothing to do
};
